export default {"src":"/_next/static/media/icon-email.21518998.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};